/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum VehicleField {
    Make = 'Make',
    Model = 'Model'
}

export function VehicleFieldFromJSON(json: any): VehicleField {
    return VehicleFieldFromJSONTyped(json, false);
}

export function VehicleFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleField {
    return json as VehicleField;
}

export function VehicleFieldToJSON(value?: VehicleField | null): any {
    return value as any;
}

